"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Validate_1 = require("./Utilities/Validate");
const MobileServiceTable_1 = __importDefault(require("./MobileServiceTable"));
const jsonapi_1 = __importDefault(require("./HttpClient/jsonapi"));
const graphql_1 = __importDefault(require("./HttpClient/graphql"));
const default_1 = __importDefault(require("./Auth/default"));
const idp_1 = __importDefault(require("./Auth/idp"));
const default_2 = __importDefault(require("./User/default"));
const idp_2 = __importDefault(require("./User/idp"));
const Email_1 = __importDefault(require("./Email"));
const PushNotification_1 = __importDefault(require("./PushNotification"));
const Storage_1 = __importDefault(require("./Storage"));
const Event_1 = __importDefault(require("./Event"));
const DOMStorage_1 = require("./Utilities/DOMStorage");
class MobileServiceClient {
    constructor(applicationUrl, options = {}) {
        (0, Validate_1.isString)(applicationUrl, "applicationUrl");
        (0, Validate_1.notNullOrEmpty)(applicationUrl, "applicationUrl");
        this.applicationUrl = applicationUrl;
        this.options = options;
        this.currentUser = null;
        if (options.extLocalStorage) {
            (0, DOMStorage_1.setLocalStorage)(options.extLocalStorage);
        }
        if (options.extSessionStorage) {
            (0, DOMStorage_1.setSessionStorage)(options.extSessionStorage);
        }
        this._jsonApiClient = new jsonapi_1.default(applicationUrl, options);
        this._singleton = new Map();
    }
    saveTokens(accessToken, refreshToken, expiry) {
        if (!accessToken) {
            console.error("missing accessToken");
            return;
        }
        if (!refreshToken) {
            console.error("missing refreshToken");
            return;
        }
        if (!expiry) {
            console.error("missing expiry");
            return;
        }
        this._jsonApiClient.saveTokenset({
            rt: refreshToken,
            at: accessToken,
            exp: expiry,
        });
    }
    get auth() {
        if (this._singleton.has("auth") === false) {
            const instance = this.options.useIdentityProvider === true
                ? new idp_1.default(this)
                : new default_1.default(this);
            this._singleton.set("auth", instance);
        }
        return this._singleton.get("auth");
    }
    get user() {
        if (this._singleton.has("user") === false) {
            const instance = this.options.useIdentityProvider === true
                ? new idp_2.default(this)
                : new default_2.default(this);
            this._singleton.set("user", instance);
        }
        return this._singleton.get("user");
    }
    getTable(tableName) {
        (0, Validate_1.isString)(tableName, "tableName");
        (0, Validate_1.notNullOrEmpty)(tableName, "tableName");
        return new MobileServiceTable_1.default(tableName, this);
    }
    get email() {
        if (this._singleton.has("email") === false) {
            this._singleton.set("email", new Email_1.default(this));
        }
        return this._singleton.get("email");
    }
    get gql() {
        if (this._singleton.has("gql") === false) {
            this._singleton.set("gql", new graphql_1.default(this));
        }
        return this._singleton.get("gql");
    }
    get push() {
        if (this._singleton.has("push") === false) {
            this._singleton.set("push", new PushNotification_1.default(this));
        }
        return this._singleton.get("push");
    }
    get storage() {
        if (this._singleton.has("storage") === false) {
            this._singleton.set("storage", new Storage_1.default(this));
        }
        return this._singleton.get("storage");
    }
    get event() {
        if (this._singleton.has("event") === false) {
            this._singleton.set("event", new Event_1.default(this));
        }
        return this._singleton.get("event");
    }
    invokeMethod(methodName, invokeData, forceEncrypt) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const targetUrl = `${this.applicationUrl}/api/${methodName}`;
                let encryption;
                encryption = (() => {
                    const encryptionOptions = this.options.payloadEncryption;
                    if (encryptionOptions &&
                        encryptionOptions.enforcement.includes("FUNCTION")) {
                        return true;
                    }
                    if (forceEncrypt !== undefined) {
                        return forceEncrypt;
                    }
                    return false;
                })();
                const { data } = yield this._jsonApiClient.request("POST", targetUrl, {
                    data: invokeData,
                    encryption,
                });
                return { data };
            }
            catch (err) {
                return {
                    error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : err.message,
                };
            }
        });
    }
    get invokeApi() {
        return this.invokeMethod;
    }
}
exports.default = MobileServiceClient;
